import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes, PartnerInfo, PartnersService } from '@core';
import { SzBrandBlockComponent, SzButtonComponent, SzIconComponent } from '@ui';

@Component({
  selector: 'app-partner-detail-page',
  templateUrl: './partner-detail.page.html',
  styleUrls: ['./partner-detail.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, SzBrandBlockComponent, SzButtonComponent, SzIconComponent]
})
export class PartnerDetailPage {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly partners: PartnersService = inject(PartnersService);

  readonly partner: PartnerInfo | null = this.resolvePartner();

  goBack(): void {
    void this.router.navigate([AppRoutes.PARTNERS]);
  }

  openSite(): void {
    if (this.partner) {
      this.partners.open(this.partner);
    }
  }

  private resolvePartner(): PartnerInfo | null {
    const id: string = this.route.snapshot.paramMap.get('id') ?? '';
    const partner: PartnerInfo | undefined = this.partners.byId(id);
    if (!partner) {
      void this.router.navigate([AppRoutes.PARTNERS]);
      return null;
    }
    return partner;
  }
}
